import { render, staticRenderFns } from "./CompaingEmailsModelsFree.vue?vue&type=template&id=16d20b67&scoped=true"
import script from "./CompaingEmailsModelsFree.vue?vue&type=script&lang=js"
export * from "./CompaingEmailsModelsFree.vue?vue&type=script&lang=js"
import style0 from "./CompaingEmailsModelsFree.vue?vue&type=style&index=0&id=16d20b67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d20b67",
  null
  
)

export default component.exports